import { SystemEntity } from '../../models';
import { ROUTE_PREFIX } from '../../services/tenants/tenants.service';
import { PipelineActionEntity } from '../pipeline/pipeline.constants';

export const URL_WELCOME = ['/welcome'];

export const ROUTE_PREFIX_ADMINISTRATION = ['system-administration'];

export const URL_ADMINISTRATION_APPEARANCE = [
    ...ROUTE_PREFIX_ADMINISTRATION,
    'appearance',
];
export const URL_ADMINISTRATION_FLEXI_LISTS = [
    ...ROUTE_PREFIX_ADMINISTRATION,
    'flexi-lists',
];
export const URL_ADMINISTRATION_REFERENCE_DATA = [
    ...ROUTE_PREFIX_ADMINISTRATION,
    'reference-data',
];
export const URL_ADMINISTRATION_OVERVIEW = [
    ...ROUTE_PREFIX_ADMINISTRATION,
    'overview',
];
export const URL_ADMINISTRATION_PRODUCTS = [
    ...ROUTE_PREFIX_ADMINISTRATION,
    'products',
];
export const URL_ADMINISTRATION_PRODUCT_TYPES = [
    ...URL_ADMINISTRATION_PRODUCTS,
    'types',
];
export const URL_ADMINISTRATION_BENCHMARKS = [
    ...URL_ADMINISTRATION_PRODUCTS,
    'benchmarks',
];
export const URL_ADMINISTRATION_MANDATES = [
    ...URL_ADMINISTRATION_PRODUCTS,
    'mandates',
];
export const URL_ADMINISTRATION_MANDATE_GROUPS = [
    ...URL_ADMINISTRATION_PRODUCTS,
    'mandate-groups',
];
export const URL_ADMINISTRATION_OBJECTIVES = [
    ...URL_ADMINISTRATION_PRODUCTS,
    'objectives',
];
export const URL_ADMINISTRATION_RISK_LEVELS = [
    ...URL_ADMINISTRATION_PRODUCTS,
    'risk-levels',
];
export const URL_ADMINISTRATION_FEE_STRUCTURES = [
    ...URL_ADMINISTRATION_PRODUCTS,
    'fee-structures',
];
export const URL_ADMINISTRATION_SALUTATION = [
    ...URL_ADMINISTRATION_REFERENCE_DATA,
    'salutation',
];
export const URL_ADMINISTRATION_ROLES_AND_RELATIONSHIPS = [
    ...ROUTE_PREFIX_ADMINISTRATION,
    'roles-and-relationships',
];
export const URL_ADMINISTRATION_TAGS = [...ROUTE_PREFIX_ADMINISTRATION, 'tags'];
export const URL_ADMINISTRATION_GEOGRAPHIC_DATA = [
    ...ROUTE_PREFIX_ADMINISTRATION,
    'geographic-data',
];
export const URL_ADMINISTRATION_COUNTRIES = [
    ...URL_ADMINISTRATION_GEOGRAPHIC_DATA,
    'countries',
];
export const URL_ADMINISTRATION_CURRENCIES = [
    ...URL_ADMINISTRATION_GEOGRAPHIC_DATA,
    'currencies',
];
export const URL_ADMINISTRATION_TEMPLATES = [
    ...ROUTE_PREFIX_ADMINISTRATION,
    'documents',
];
export const URL_ADMINISTRATION_TEMPLATES_DOCUMENT_TYPES = [
    ...URL_ADMINISTRATION_TEMPLATES,
    'types',
];
export const URL_ADMINISTRATION_TEMPLATES_DOCUMENT_TEMPLATES = [
    ...URL_ADMINISTRATION_TEMPLATES,
    'templates',
];
export const URL_ADMINISTRATION_TEMPLATES_DOCUMENT_REQUIREMENT_TYPES = [
    ...URL_ADMINISTRATION_TEMPLATES,
    'requirement-types',
];
export const URL_ADMINISTRATION_USERS_AND_TEAMS = [
    ...ROUTE_PREFIX_ADMINISTRATION,
    'access-control',
];
export const URL_ADMINISTRATION_USERS_AND_TEAMS_USERS = [
    ...URL_ADMINISTRATION_USERS_AND_TEAMS,
    'users',
];
export const URL_ADMINISTRATION_USERS_AND_TEAMS_TEAMS = [
    ...URL_ADMINISTRATION_USERS_AND_TEAMS,
    'teams',
];
export const URL_ADMINISTRATION_USERS_AND_TEAMS_ROLES = [
    ...URL_ADMINISTRATION_USERS_AND_TEAMS,
    'roles',
];
export const URL_ADMINISTRATION_WEB_HOOKS = [
    ...ROUTE_PREFIX_ADMINISTRATION,
    'web-hooks',
];
export const URL_ADMINISTRATION_INTERFACE_CONSOLE = [
    ...ROUTE_PREFIX_ADMINISTRATION,
    'interface-console',
];
export const URL_ADMINISTRATION_INTERFACE_CONSOLE_BATCH = [
    ...URL_ADMINISTRATION_INTERFACE_CONSOLE,
    'batch',
];
export const URL_ADMINISTRATION_INTERFACE_TEST_FORMS = [
    ...ROUTE_PREFIX_ADMINISTRATION,
    'test-forms',
];
export const URL_ADMINISTRATION_REGIONS = [
    ...URL_ADMINISTRATION_REFERENCE_DATA,
    'regions',
];

export const URL_ADMINISTRATION_SYSTEM_LOG = [
    ...ROUTE_PREFIX_ADMINISTRATION,
    'system-log',
];

export const URL_ERROR = ['error'];
export const URL_ARTICLES = ['articles'];
export const URL_ARTICLES_LISTING = [...URL_ARTICLES, 'articles'];
export const URL_ARTICLES_DISTRIBUTION = [...URL_ARTICLES, 'distribution'];
export const URL_CASES = ['cases'];
export const URL_CASES_LISTING = [...URL_CASES, 'listing'];
export const URL_CASES_LISTING_GRID = [...URL_CASES_LISTING, 'grid'];
export const URL_CASES_LISTING_CARDS = [...URL_CASES_LISTING, 'cards'];
export const URL_CASES_CHARTS = [...URL_CASES, 'charts'];
export const URL_CASES_WORK_SUB_ITEM = ['work-list', 'work-item'];
export const URL_CASES_APP = ['app'];
export const URL_CASES_STAGE = ['review-stage'];
export const URL_CASES_KYC_MODE = ['kyc'];
export const URL_CASES_KYC_MODE_APPS = ['kyc', 'apps'];

export const URL_CONTACTS = ['contacts'];
export const URL_CONTACTS_PEOPLE = [...URL_CONTACTS, 'people'];
export const URL_CONTACTS_PEOPLE_LISTING = [...URL_CONTACTS_PEOPLE, 'list'];
export const URL_CONTACTS_PEOPLE_CHARTS = [...URL_CONTACTS_PEOPLE, 'charts'];
export const URL_CONTACTS_ORGANISATIONS = [...URL_CONTACTS, 'organisations'];
export const URL_CONTACTS_ORGANISATIONS_LISTING = [
    ...URL_CONTACTS_ORGANISATIONS,
    'list',
];
export const URL_CONTACTS_ORGANISATIONS_CHARTS = [
    ...URL_CONTACTS_ORGANISATIONS,
    'charts',
];
export const URL_CONTACTS_INTERMEDIARIES = [...URL_CONTACTS, 'intermediaries'];
export const URL_CONTACTS_INTERMEDIARIES_LISTING = [
    ...URL_CONTACTS_INTERMEDIARIES,
    'list',
];
export const URL_CONTACTS_ADVISERS = [...URL_CONTACTS, 'advisers'];
export const URL_CONTACTS_ADVISERS_LISTING = [...URL_CONTACTS_ADVISERS, 'list'];
export const URL_CONTACTS_PRODUCT_PROVIDERS = [
    ...URL_CONTACTS,
    'product-providers',
];
export const URL_CONTACTS_PRODUCT_PROVIDERS_LISTING = [
    ...URL_CONTACTS_PRODUCT_PROVIDERS,
    'list',
];
export const URL_CONTACTS_LEADS = [...URL_CONTACTS, 'leads'];
export const URL_CONTACTS_LEADS_LISTING = [...URL_CONTACTS_LEADS, 'list'];
export const URL_CONTACTS_LEADS_CHARTS = [...URL_CONTACTS_LEADS, 'charts'];
export const URL_CONTACTS_CLIENT_RELATIONSHIPS = [...URL_CONTACTS, 'clients'];
export const URL_CONTACTS_CLIENT_RELATIONSHIPS_LISTING = [
    ...URL_CONTACTS_CLIENT_RELATIONSHIPS,
    'list',
];
export const URL_CONTACTS_CLIENT_RELATIONSHIPS_CHARTS = [
    ...URL_CONTACTS_CLIENT_RELATIONSHIPS,
    'charts',
];
export const URL_CONTACTS_EXTERNAL_USERS = [...URL_CONTACTS, 'external-users'];
export const URL_CLIENT = [...URL_CONTACTS, 'clients'];
export const URL_CONTACT = [...URL_CONTACTS, 'contact'];
export const URL_DASHBOARDS = ['dashboards'];
export const URL_DASHBOARD = [...URL_DASHBOARDS, 'dashboard'];
export const URL_DOCUMENTS_CHECKLIST = ['documents-checklist'];
export const URL_ED_MESSAGE_BATCH = [
    ...ROUTE_PREFIX_ADMINISTRATION,
    'interface-console',
    'batch',
];
export const URL_FEED = ['feed'];
export const URL_HOME = ['home'];
export const URL_ACTIVITIES = ['activities'];
export const URL_INBOX = [...URL_ACTIVITIES, 'inbox'];
export const URL_INBOX_CHARTS = [...URL_INBOX, 'charts'];
export const URL_MARKETING = ['marketing'];
export const URL_MARKETING_CAMPAIGN_RESPONSES = [
    ...URL_MARKETING,
    'campaign-responses',
];
export const URL_MARKETING_CAMPAIGNS = [...URL_MARKETING, 'campaigns'];
export const URL_MARKETING_EVENTS = [...URL_MARKETING, 'events'];

export const URL_LISTS = ['lists'];
export const URL_CALENDAR = [...URL_ACTIVITIES, 'calendar'];
export const URL_NOTIFICATIONS = ['notifications'];
export const URL_PIPELINE = ['pipeline'];
export const URL_PIPELINE_KANBAN = [...URL_PIPELINE, 'kanban'];
export const URL_PIPELINE_LIST = [...URL_PIPELINE, 'list'];
export const URL_PIPELINE_CHARTS = [...URL_PIPELINE, 'charts'];
export const URL_PIPELINE_OPPORTUNITY = [...URL_PIPELINE, 'opportunity'];
export const URL_PRODUCTS = ['products'];
export const URL_PRODUCTS_LISTING = [...URL_PRODUCTS, 'listing'];
export const URL_PRODUCTS_CHARTS = [...URL_PRODUCTS, 'charts'];
export const URL_QUEUES = ['queues'];
export const URL_RECENT_RECORDS = ['recent-records'];
export const URL_TASKS = [...URL_ACTIVITIES, 'tasks'];
export const URL_EXTERNAL_TASKS = [...URL_ACTIVITIES, 'external-tasks'];
export const URL_TASKS_CHARTS = [...URL_TASKS, 'charts'];
export const URL_TEAMS = ['teams'];
export const URL_UNIMPLEMENTED = [...ROUTE_PREFIX];
export const URL_DATA = ['data'];
export const URL_DATA_MANAGEMENT = ['data-management'];
export const URL_EXPORTS = ['exports'];
export const URL_IMPORTS = ['imports'];
export const URL_DATA_IMPORT = [...URL_DATA, ...URL_IMPORTS];
export const URL_DATA_EXPORT = [...URL_DATA, ...URL_EXPORTS];
export const URL_DATA_MANAGEMENT_EXPORT = [
    ...URL_DATA_MANAGEMENT,
    ...URL_EXPORTS,
];
export const URL_DATA_MANAGEMENT_IMPORT = [
    ...URL_DATA_MANAGEMENT,
    ...URL_IMPORTS,
];
export const URL_DATA_PENDING_CHANGES = [...URL_DATA, 'pending-changes'];
export const URL_MY_ACCOUNT = ['my-account'];
export const URL_UNBLU = ['unblu'];
export const URL_NUDGES = ['nudges'];

export const LEGACY_ENTITY_ROUTE_MAP: Record<string, boolean> = {
    [SystemEntity.Portfolio]: true,
    [SystemEntity.ClientProduct]: true,
};

export const ENTITY_ROUTE_MAP: Record<string, string[]> = {
    [SystemEntity.Lead]: URL_CONTACTS_LEADS,
    [PipelineActionEntity.OpportunityItem]: URL_PIPELINE_OPPORTUNITY,
    [SystemEntity.Activity]: URL_INBOX,
    [SystemEntity.ActivityParty]: URL_UNIMPLEMENTED,
    [SystemEntity.Adviser]: URL_CONTACTS_ADVISERS,
    [SystemEntity.AmlReport]: URL_UNIMPLEMENTED,
    [SystemEntity.Appointment]: URL_INBOX,
    [SystemEntity.AppStatus]: URL_UNIMPLEMENTED,
    [SystemEntity.Article]: URL_ARTICLES_LISTING,
    [SystemEntity.ArticleDistribution]: URL_ARTICLES_DISTRIBUTION,
    [SystemEntity.BankAccount]: URL_PRODUCTS,
    [SystemEntity.Benchmark]: URL_UNIMPLEMENTED,
    [SystemEntity.Campaign]: URL_MARKETING_CAMPAIGNS,
    [SystemEntity.Event]: URL_MARKETING_EVENTS,
    [SystemEntity.Case]: URL_CASES,
    [SystemEntity.Client]: URL_CLIENT,
    [SystemEntity.ClientProduct]: URL_PRODUCTS,
    [SystemEntity.ClientProductRelationship]: URL_UNIMPLEMENTED,
    [SystemEntity.ContactPoint]: URL_UNIMPLEMENTED,
    [SystemEntity.DataLock]: URL_UNIMPLEMENTED,
    [SystemEntity.DocumentTemplate]: URL_UNIMPLEMENTED,
    [SystemEntity.EdsMessageBatch]: URL_ED_MESSAGE_BATCH,
    [SystemEntity.ElectronicAddress]: URL_UNIMPLEMENTED,
    [SystemEntity.Email]: URL_INBOX,
    [SystemEntity.Engagement]: URL_INBOX,
    [SystemEntity.Export]: URL_DATA_EXPORT,
    [SystemEntity.ExternalUser]: URL_CONTACTS_EXTERNAL_USERS,
    [SystemEntity.ExternalTask]: URL_EXTERNAL_TASKS,
    [SystemEntity.Feed]: URL_FEED,
    [SystemEntity.FeedNudge]: URL_UNIMPLEMENTED,
    [SystemEntity.FeeStructure]: URL_UNIMPLEMENTED,
    [SystemEntity.Import]: URL_DATA_IMPORT,
    [SystemEntity.InsuranceAccount]: URL_PRODUCTS,
    [SystemEntity.Intermediary]: URL_CONTACTS_INTERMEDIARIES,
    [SystemEntity.InvestmentAccount]: URL_PRODUCTS,
    [SystemEntity.LendingAccount]: URL_PRODUCTS,
    [SystemEntity.Letter]: URL_INBOX,
    [SystemEntity.List]: URL_LISTS,
    [SystemEntity.Mandate]: URL_UNIMPLEMENTED,
    [SystemEntity.Message]: URL_INBOX,
    [SystemEntity.AmlRisk]: URL_UNIMPLEMENTED,
    [SystemEntity.Note]: URL_UNIMPLEMENTED,
    [SystemEntity.Notification]: URL_NOTIFICATIONS,
    [SystemEntity.Nudge]: URL_NUDGES,
    [SystemEntity.NudgeLog]: URL_UNIMPLEMENTED,
    [SystemEntity.Objective]: URL_UNIMPLEMENTED,
    [SystemEntity.Opportunity]: URL_PIPELINE,
    [SystemEntity.OpportunityTeamMember]: URL_PIPELINE_OPPORTUNITY,
    [SystemEntity.Organisation]: URL_CONTACTS_ORGANISATIONS,
    [SystemEntity.Party]: URL_CONTACT,
    [SystemEntity.PartyRole]: URL_CLIENT,
    [SystemEntity.PartyRoleAccess]: URL_UNIMPLEMENTED,
    [SystemEntity.PendingChange]: URL_DATA_PENDING_CHANGES,
    [SystemEntity.Person]: URL_CONTACTS_PEOPLE,
    [SystemEntity.PhoneAddress]: URL_UNIMPLEMENTED,
    [SystemEntity.PhoneCall]: URL_INBOX,
    [SystemEntity.Portfolio]: URL_PRODUCTS,
    [SystemEntity.PostalAddress]: URL_UNIMPLEMENTED,
    [SystemEntity.PotentialDuplicate]: URL_UNIMPLEMENTED,
    [SystemEntity.Process]: URL_UNIMPLEMENTED,
    [SystemEntity.Product]: URL_UNIMPLEMENTED,
    [SystemEntity.ProductGroup]: URL_UNIMPLEMENTED,
    [SystemEntity.ProductProvider]: URL_CONTACTS_PRODUCT_PROVIDERS,
    [SystemEntity.QueueItem]: URL_QUEUES,
    [SystemEntity.Relationship]: URL_UNIMPLEMENTED,
    [SystemEntity.Reminder]: URL_UNIMPLEMENTED,
    [SystemEntity.RiskLevel]: URL_UNIMPLEMENTED,
    [SystemEntity.SocialAddress]: URL_UNIMPLEMENTED,
    [SystemEntity.Tag]: URL_UNIMPLEMENTED,
    [SystemEntity.Task]: URL_TASKS,
    [SystemEntity.Team]: URL_TEAMS,
    [SystemEntity.TimeBooking]: URL_UNIMPLEMENTED,
    [SystemEntity.UserDashboard]: URL_DASHBOARDS,
    [SystemEntity.WebHook]: URL_UNIMPLEMENTED,
    [SystemEntity.WorkItem]: URL_CASES_WORK_SUB_ITEM,
};

export const ENTITY_LISTING_MAP: Record<string, string[]> = {
    [SystemEntity.Adviser]: URL_CONTACTS_ADVISERS_LISTING,
    [SystemEntity.Client]: URL_CONTACTS_CLIENT_RELATIONSHIPS_LISTING,
    [SystemEntity.Person]: URL_CONTACTS_PEOPLE_LISTING,
    [SystemEntity.ExternalUser]: URL_CONTACTS_EXTERNAL_USERS,
    [SystemEntity.Intermediary]: URL_CONTACTS_INTERMEDIARIES_LISTING,
    [SystemEntity.Lead]: URL_CONTACTS_LEADS_LISTING,
    [SystemEntity.Organisation]: URL_CONTACTS_ORGANISATIONS_LISTING,
    [SystemEntity.ProductProvider]: URL_CONTACTS_PRODUCT_PROVIDERS_LISTING,
};

export const ADMIN_ENTITY_ROUTE_MAP: Record<string, string[]> = {
    [SystemEntity.User]: URL_ADMINISTRATION_USERS_AND_TEAMS_USERS,
    [SystemEntity.Team]: URL_ADMINISTRATION_USERS_AND_TEAMS_TEAMS,
};
